import { PropsWithChildren } from 'react'

type ServicePriceTagProps = {}

export const ServicePriceTag = ({
  children
}: PropsWithChildren<ServicePriceTagProps>) => {
  return <div className="flex justify-between">{children}</div>
}
